import "core-js/modules/web.dom.iterable";
import request from "@/util/http";
import qs from "qs"; // 获取树形结构的节点

export function getTreeNode() {
  var url = arguments.length <= 0 ? undefined : arguments[0];
  return request({
    url: url,
    method: "get"
  });
} // 获取角色表格数据

export function getRoleTableData(query) {
  return request({
    url: "/admin/role/page?" + qs.stringify(query),
    method: "get"
  });
} // 新增、编辑角色

export function addRole(query) {
  if (query.status === "add") {
    return request({
      url: "/admin/role",
      method: "post",
      data: query
    });
  }

  if (query.status === "edit") {
    return request({
      url: "/admin/role",
      method: "put",
      data: query
    });
  }
} // 删除单个角色数据

export function removeRole(query) {
  return request({
    url: "/admin/role/".concat(query.id, "?").concat(qs.stringify(query)),
    method: "delete"
  });
} // 通过id删除角色

export function removeRoleById(id) {
  return request({
    url: "/admin/role/".concat(id),
    method: "delete"
  });
} // 批量删除角色数据

export function removeMultipleRole(query) {
  var params = "";
  query.idArr.forEach(function (item) {
    params += "ids=".concat(item, "&");
  });
  return request({
    url: "/admin/role/batch",
    method: "delete",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    data: params
  });
} // 获取当前角色权限

export function getRolePermission(query) {
  return request({
    url: "admin/menu/tree/".concat(query.roleId, "?roleId=").concat(query.roleId),
    method: "get"
  });
} // 更新角色权限

export function updateRolePermission(query) {
  var params = {
    roleId: query.roleId,
    menuIds: ""
  };
  query.menuIds.forEach(function (item) {
    params.menuIds += "".concat(item, ",");
  });
  return request({
    url: "admin/role/menu",
    method: "put",
    headers: {
      "content-type": "application/json"
    },
    data: params
  });
} // 获得用户分页

export function getDeptUser(query) {
  return request({
    url: "admin/user/page?".concat(qs.stringify(query)),
    method: "get"
  });
} // 保存角色用户信息

export function saveRoleUsers(query) {
  /*let params = `roleId=${query.roleId}&deptId=${query.deptId}&all=${
        false
    }`;
    // if(!query.all){
        query.users.forEach(item => {
            params += `&users=${item}`;
        });
    // }*/
  return request({
    url: "admin/role/saveRoleUsers",
    method: "post",
    headers: {
      "content-type": "application/json"
    },
    data: query
  });
} // 根据角色获得用户信息

export function getRoleUsers(query) {
  return request({
    url: "admin/role/getRoleUsers?roleId=".concat(query.roleId),
    method: "get"
  });
} // 根据角色获得用户信息(新)

export function getListRoleUsers(query) {
  return request({
    url: "admin/role/listRoleUsers?roleId=".concat(query.roleId),
    method: "get"
  });
} // 根据用户角色类型

export function getRoleUserTypes(query) {
  return request({
    url: "admin/role/getRoleUserTypes?roleId=".concat(query.roleId),
    method: "get"
  });
} // 保存用户角色类型

export function saveRoleUserTypes(query) {
  return request({
    url: "admin/role/saveRoleUserTypes?".concat(qs.stringify(query)),
    method: "get"
  });
}
export function getRoleList(query) {
  return request({
    url: "admin/role/getRoleList",
    method: "post",
    data: []
  });
}
export function getList(query) {
  return request({
    url: "admin/role/list",
    method: "get"
  });
}